import ConfigBuilder from '@react-form-fields/material-ui/config/builder';
import lang from '@react-form-fields/material-ui/lang/pt-br';

export const fieldConfig = new ConfigBuilder().fromLang(lang).build();
